__turbopack_context__.v({
  "DetailsPane": "DetailsPane-module-scss-module__w72qVa__DetailsPane",
  "IconButtonActiveAnimation": "DetailsPane-module-scss-module__w72qVa__IconButtonActiveAnimation",
  "PointRowAvatar": "DetailsPane-module-scss-module__w72qVa__PointRowAvatar",
  "fadeAnimation": "DetailsPane-module-scss-module__w72qVa__fadeAnimation",
  "pointsList": "DetailsPane-module-scss-module__w72qVa__pointsList",
  "segmentRowIsSelected": "DetailsPane-module-scss-module__w72qVa__segmentRowIsSelected",
  "segmentsList": "DetailsPane-module-scss-module__w72qVa__segmentsList",
});
